import { Button } from "@holigral/shared/ui/components/ui/button"
import { useResendVerifyEmail } from "@/profile"
import { useT } from "@/i18n"

export default function RequestVerifyEmail() {
  const { t } = useT("auth")
  const resendEmail = useResendVerifyEmail()

  return (
    <div>
      <p className="mb-4">{t("verifyPrompt")}</p>
      <Button variant="ghost" onClick={resendEmail}>
        {t("common:resendVerifyEmail")}
      </Button>
    </div>
  )
}
